<p-dialog
  [(visible)]="formLoaded"
  [modal]="true"
  [closable]="false"
  [closeOnEscape]="true"
  [dismissableMask]="true"
  [baseZIndex]="10000"
  [style]="{ width: '100vw', minHeight: '100vh' }"
>
  <ng-template pTemplate="content" *ngIf="formLoaded">
    @switch (selfServiceType) {
      @case (RecrutimentSelfServiceType.ADDRESS_DECLARATION) {
        <address-declaration [form]="selfServiceForm"></address-declaration>
      }
      @case (RecrutimentSelfServiceType.DETASSAZIONE_COMMERCIO) {
        <commerce-tax-relief [form]="selfServiceForm" [activityId]="requestId"></commerce-tax-relief>
      }
      @case (RecrutimentSelfServiceType.EMPLOYMENT_HISTORY) {
        <employment-history
          [form]="selfServiceForm"
          [me]="me"
          [hiredAtYear]="hiredAtYear"
          [activityId]="requestId"
          [confirmedFields]="confirmedEmploymentHistoryFields"
          [userCompany]="me?.company ?? ''"
          (completed)="onEmploymentHistoryCompleted()"
        ></employment-history>
      }
      @case (RecrutimentSelfServiceType.FIRST_EMPLOYMENT) {
        <first-employment [form]="selfServiceForm"></first-employment>
      }
      @case (RecrutimentSelfServiceType.PAYMENT_DETAILS_CHANGE) {
        <payment-details [form]="selfServiceForm"></payment-details>
      }
      @case (RecrutimentSelfServiceType.PERSONAL_CONTACTS_DETAILS) {
        <personal-contacts [form]="selfServiceForm" [me]="me"></personal-contacts>
      }
      @case (RecrutimentSelfServiceType.PREVIOUS_WORK_ACTIVITIES) {
        <previous-work-activities [form]="selfServiceForm"></previous-work-activities>
      }
      @case (RecrutimentSelfServiceType.RETIREMENT_PLAN) {
        <retirement-plan [form]="selfServiceForm"></retirement-plan>
      }
      @case (RecrutimentSelfServiceType.TFR_DECLARATION) {
        <tfr-declaration [form]="selfServiceForm"></tfr-declaration>
      }
      @case (RecrutimentSelfServiceType.DETASSAZIONE_TURISMO) {
        <tourism-tax-relief [form]="selfServiceForm" [activityId]="requestId"></tourism-tax-relief>
      }
      @default {
        Non è presente un form per questo tipo di attività
      }
    }

    @if (
      isCompleted &&
      (selfServiceType === RecrutimentSelfServiceType.FIRST_EMPLOYMENT ||
        selfServiceType === RecrutimentSelfServiceType.RETIREMENT_PLAN ||
        selfServiceType === RecrutimentSelfServiceType.PREVIOUS_WORK_ACTIVITIES ||
        selfServiceType === RecrutimentSelfServiceType.TFR_DECLARATION)
    ) {
      <p>
        <strong class="text-red-500">{{ 'selfservice-requests.complete.label' | translate }}</strong>
      </p>
    }
  </ng-template>

  <ng-template pTemplate="footer">
    @if (!isCompleted && selfServiceType !== RecrutimentSelfServiceType.EMPLOYMENT_HISTORY) {
      <button
        pButton
        type="button"
        [label]="'selfservice.dialog.save-draft' | translate"
        (click)="saveDraft()"
        [disabled]="isSaving || tfrConfirmationVisible"
        [loading]="isSaving"
      ></button>
    }
    @if (
      selfServiceType !== RecrutimentSelfServiceType.EMPLOYMENT_HISTORY &&
      (!isCompleted || tfrInCompanyModificationMode)
    ) {
      <button
        pButton
        type="button"
        [label]="'selfservice.dialog.confirm' | translate"
        (click)="save()"
        [disabled]="
          selfServiceForm.invalid ||
          (tfrInCompanyModificationMode && !isTfrInCompanySelected()) ||
          tfrConfirmationVisible
        "
        [loading]="isSaving"
      ></button>
    }
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="tfrConfirmationVisible"
  [modal]="true"
  [closable]="false"
  [closeOnEscape]="false"
  [style]="{ width: 'min(560px, 90vw)' }"
>
  <ng-template pTemplate="header">
    <h2>Conferma selezione</h2>
  </ng-template>

  <div class="column">
    <p [innerHTML]="getTfrConfirmationMessageKey() | translate"></p>
  </div>

  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      [label]="'selfservice.dialog.cancel' | translate"
      (click)="cancelTfrConfirmation()"
      class="mr-2"
    ></button>
    <button
      pButton
      type="button"
      [label]="'selfservice-request.tfr-declaration.confirmation.confirm.label' | translate"
      (click)="confirmTfrSubmission()"
    ></button>
  </ng-template>
</p-dialog>
<p-toast [baseZIndex]="10001"></p-toast>
